<template>
  <div class="px-7" ref="subMenuDiffuseLoadsRef">
    <v-btn-toggle
      v-model="optionSelected"
      mandatory
      style="border: 1px solid #95a1ec"
      background-color="#212a35"
      :class="width > 300 ? 'd-flex flex-row' : 'd-flex flex-column'"
    >
      <v-btn
        :value="'DBO'"
        color="#95A1EC"
        height="28"
        class="btn-group flex-grow-1"
      >
        Carga DBO
      </v-btn>
      <v-btn
        :value="'NT'"
        color="#95A1EC"
        height="28"
        class="btn-group flex-grow-1"
      >
        Carga NT
      </v-btn>
      <v-btn
        :value="'PT'"
        color="#95A1EC"
        height="28"
        class="btn-group flex-grow-1"
      >
        Carga PT
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: 'SubMenuDiffuseLoads',
  props: ['layer', 'group'],
  data: () => ({
    optionSelected: undefined,
    width: 0,
    observer: null,
  }),
  mounted() {
    this.observer = new ResizeObserver(this.handleResize);
    this.observer.observe(this.$refs.subMenuDiffuseLoadsRef);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  watch: {
    optionSelected() {
      this.changeLayersOfPesticides();
    },
  },
  methods: {
    handleResize(entries) {
      for (const entry of entries) {
        const width = entry.contentRect.width;
        this.width = width;
      }
    },
    changeLayersOfPesticides() {
      if (this.optionSelected === 'DBO') {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 504},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 505},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: true, layerId: 503},
        });
      }
      if (this.optionSelected === 'NT') {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 503},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 505},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: true, layerId: 504},
        });
      }
      if (this.optionSelected === 'PT') {
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 503},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: false, layerId: 504},
        });
        this.$emit('changeInputMenu', {
          eventName: 'changeEnabledSublayer',
          params: {visible: true, layerId: 505},
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-transform: none;
  color: #95a1ec;
  border: 1px solid #95a1ec;
}

::v-deep .theme--dark.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #95a1ec !important;
}

::v-deep .v-btn-toggle > .v-btn.v-btn--active {
  color: #95a1ec !important;
  opacity: 1;
}

::v-deep .theme--dark.v-btn.v-btn--has-bg {
  background-color: #212a35 !important;
}
</style>
